import { FormControl, Select, MenuItem } from '@mui/material';

interface KodaiQuarkStatSelectProps {
  value: 'attack' | 'special_attack';
  onChange: (value: 'attack' | 'special_attack') => void;
  // カード内でクリック伝播を止めたい場合に利用する
  stopPropagation?: boolean;
}

function KodaiQuarkStatSelect({ value, onChange, stopPropagation }: KodaiQuarkStatSelectProps) {
  return (
    <FormControl size="small" sx={{ mt: 0.25, width: '16ch' }}>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value as 'attack' | 'special_attack')}
        onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
        sx={{
          fontSize: '0.7rem',
          '& .MuiSelect-select': {
            padding: '1px 4px',
            textAlign: 'center',
          },
        }}
      >
        <MenuItem value="attack" sx={{ fontSize: '0.7rem', justifyContent: 'center' }}>
          攻撃
        </MenuItem>
        <MenuItem value="special_attack" sx={{ fontSize: '0.7rem', justifyContent: 'center' }}>
          特攻
        </MenuItem>
      </Select>
    </FormControl>
  );
}

export default KodaiQuarkStatSelect;
